import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Skeleton from 'react-loading-skeleton';
import Permission from './Permission';

const style = theme => ({
  root: {
    listStyle: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  },
});

class Permissions extends Component {
  renderLoading = () => (
    <div>
      {Array(10)
        .fill(null)
        .map((val, i) => (
          <ul key={i}>
            <Skeleton />
          </ul>
        ))}
    </div>
  );

  permissionsArray = [];

  onReceivePermission(updateAllPermission) {
    this.permissionsArray.push(updateAllPermission);
  }

  permisssionMethod() {}

  componentDidMount() {
    if (typeof this.props.getUpdateAllPermissions === 'function') {
      this.props.getUpdateAllPermissions(this.updateAllPermission.bind(this));
    }
  }

  updateAllPermission(value) {
    const result = this.permissionsArray.map(fnPermission => fnPermission(value));
    return result;
  }

  render() {
    const {
      template, classes, onChange, readOnly, isLoading,
    } = this.props;

    if (isLoading) {
      return this.renderLoading();
    }

    return (
      <ul className={classes.root}>
        {template.map((resource, idx) => (
          <Permission
            getUpdateAllPermission={this.onReceivePermission.bind(this)}
            key={idx}
            readOnly={readOnly}
            resource={resource}
            onChange={onChange}
          />
        ))}
      </ul>
    );
  }
}

Permissions.propTypes = {
  template: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default withStyles(style)(Permissions);
